import { createSlice } from "@reduxjs/toolkit";
import { fetchPRAnalytics, fetchPRs } from "./thunk";

interface PRState {
  prList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  analyticsData: any;
  loadingAnalytics: boolean;
  // selectedRFQ: any;
}

const initialState: PRState = {
  prList: [],
  rowCount: 0,
  loading: false,
  error: null,
  analyticsData: null,
  loadingAnalytics: false,
  // selectedRFQ: null,
};

const prSlice = createSlice({
  name: "pr",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPRs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPRs.fulfilled, (state, action) => {
        state.loading = false;
        state.prList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPRs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch PR List";
      })
      .addCase(fetchPRAnalytics.pending, (state) => {
        state.loadingAnalytics = true;
      })
      .addCase(fetchPRAnalytics.fulfilled, (state, action) => {
        state.loadingAnalytics = false;
        state.analyticsData = action.payload;
      })
      .addCase(fetchPRAnalytics.rejected, (state) => {
        state.loadingAnalytics = false;
      });

  },
});

export default prSlice.reducer;
